<template>
  <div class="alarm-level-wrap">
    <div class="alarm-level" :class="className">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    text() {
      const dict = ['优', '良', '轻度', '中度', '重度', '严重'];
      return dict[this.level];
    },
    className() {
      let level = parseInt(this.level);
      if (isNaN(level)) return 0;
      level = level > 5 ? 5 : level < 0 ? 0 : level;
      return `level${level + 1}`;
    }
  }
};
</script>

<style lang="scss">
.alarm-level-wrap {
  $colors: #24ac45, #f5b615, #f66b1c, #9f041b, #53188c, #180e6d;
  .alarm-level {
    height: 4.6vw;
    line-height: 4.6vw;
    padding: 0 8px;
    min-width: 3.8vw;
    position: relative;
    overflow: unset;
    font-size: 2.6vw;
    text-align: center;
    bottom: 1vw;
    margin-right: 14vw;
    &::before {
      content: '';
      border-top: 2.3vw solid transparent;
      border-bottom: 2.3vw solid transparent;
      position: absolute;
      left: -1.3vw;
      top: 0;
      bottom: 0;
    }
    &::after {
      content: '';
      border-top: 2.3vw solid transparent;
      border-bottom: 2.3vw solid transparent;
      position: absolute;
      right: -1.3vw;
      top: 0;
      bottom: 0;
    }
  }
  @each $c in $colors {
    $i: index($colors, $c);
    .level#{$i} {
      background: $c;
      &::before {
        border-right: 1.3vw solid $c;
      }
      &::after {
        border-left: 1.3vw solid $c;
      }
    }
  }
}
</style>
